import api from '@/apis/audit/restoreVoucherAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('restoreVoucher', api);

const state = {
  ...crud.state,
  _config: {
    table: 'recycle_bin',
    field: {
      key: 'ref_id',
      code: 'ref_no',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
